// extracted by mini-css-extract-plugin
export default {"message":"PredioYProductor_message__IvZC+","success":"PredioYProductor_success__M4Yxa","error":"PredioYProductor_error__sc1D3","escalar":"PredioYProductor_escalar__syOcN"};